import { Link } from 'react-router-dom';
import { AppFooter } from './branding/AppFooter';
import { AppHeader } from './branding/AppHeader';
import './NotFound.css';

export function NotFound(): JSX.Element {
  return (
    <div className="bl-page">
      <AppHeader privacy="on-device" />
      <main className="bl-notfound">
        <h1>This page wandered off</h1>
        <p>Maybe a project got deleted, or maybe the URL has a typo.</p>
        <Link to="/studio" className="bl-notfound__link">
          Back to the studio
        </Link>
      </main>
      <AppFooter />
    </div>
  );
}
